import {APP_INITIALIZER, NgModule} from '@angular/core';
import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {BrowserModule} from '@angular/platform-browser';
import {environment} from '../environments/environment';
import {ErrorComponent} from './components/error/error.component';
import {AssetChartComponent} from './components/asset-chart/asset-chart.component';
import {ImComponent} from './components/im/im.component';
import {IntroComponent} from './components/intro/intro.component';
import {PwaInstallService} from './shared/_services/pwa-install.service';
import {ServiceWorkerModule} from '@angular/service-worker';
import {SharedModule} from './shared/shared.module';
import {AssetsTreeComponent} from './components/assets-tree/assets-tree.component';
import {SwiperModule} from 'ngx-swiper-wrapper';
import {MarketChartComponent} from './components/market-chart/market-chart.component';
import {OutageComponent} from './components/outage/outage.component';
import {PositionChartComponent} from './components/position-chart/position-chart.component';
import {VirtualScrollerModule} from 'ngx-virtual-scroller';
import {OutageChartComponent} from './components/outage-chart/outage-chart.component';
import {ChartPagComponent} from './components/chart-pag/chart-pag.component';
import {DateComponent} from './components/date/date.component';

const pwaInstall = (pwaService: PwaInstallService) => () => pwaService.initPwaPrompt();

@NgModule({
  bootstrap: [AppComponent],
  declarations: [
    AppComponent,
    AssetChartComponent,
    AssetsTreeComponent,
    ChartPagComponent,
    DateComponent,
    ErrorComponent,
    ImComponent,
    IntroComponent,
    MarketChartComponent,
    OutageChartComponent,
    OutageComponent,
    PositionChartComponent,
  ],
  imports: [
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    ServiceWorkerModule.register('ngsw-worker.js', {enabled: environment.withSw}),
    SharedModule,
    SwiperModule,
    VirtualScrollerModule,
  ],
  providers: [
    {provide: APP_INITIALIZER, useFactory: pwaInstall, deps: [PwaInstallService], multi: true},
  ],
})
export class AppModule {
}
